import styled from 'styled-components';

export default styled.h1`
	font-family: ${({ theme }) => theme.fonts.slabBold};
	font-size: ${({ theme }) => theme.fontSizes.xxxxl};
	color: ${({ textColor }) => textColor ? textColor : ({ theme }) => theme.colors.AGCOBlack};
`;
